<template>
  <div class="mt-5">
    <v-layout wrap>
      <v-flex>
        <v-dialog
          v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          v-if="dialog.form"
          :fullscreen="dialog.fullscreen"
          width="720"
          persistent
          scrollable>
          <v-card :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title class="d-flex align-center pa-4 popup-header">
              <div>
                <div class="caption grey--text text--darken-1">Log E-Sign</div>
                <div class="title font-weight-bold">Detail data</div>
              </div>

              <v-spacer />

              <v-icon
                @click="dialog.fullscreen = !dialog.fullscreen"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon
                @click="dialog.form = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>

            <v-divider class="mb-2" style="border-top: 2px dashed #e0e0e0;" />

            <v-card-text class="py-0 my-4" v-if="selected.detail">
              <div class="d-flex align-center mb-4">
                <v-chip
                  small
                  :color="statusColor(parsedDetail.status)"
                  text-color="white"
                  class="text-capitalize mr-2">
                  {{ parsedDetail.status || '-' }}
                </v-chip>
                <span class="body-2 grey--text">{{ selected.detail.created_at | dateTimeFull }}</span>
              </div>

              <v-simple-table dense class="detail-table mb-4">
                <tbody>
                  <tr>
                    <td class="detail-label">ID</td>
                    <td>{{ selected.detail.id }}</td>
                  </tr>
                  <tr>
                    <td class="detail-label">Jenis</td>
                    <td>{{ parsedDetail.action || '-' }}</td>
                  </tr>
                  <tr>
                    <td class="detail-label">Versi</td>
                    <td>{{ parsedDetail.version || '-' }}</td>
                  </tr>
                  <tr>
                    <td class="detail-label">NIK</td>
                    <td class="detail-mono">{{ parsedDetail.nik || '-' }}</td>
                  </tr>
                  <tr>
                    <td class="detail-label">Tampilan</td>
                    <td>{{ parsedDetail.tampilan || '-' }}</td>
                  </tr>
                  <tr>
                    <td class="detail-label">Environment</td>
                    <td>{{ parsedDetail.env || '-' }}</td>
                  </tr>
                  <tr>
                    <td class="detail-label">IP Address</td>
                    <td class="detail-mono">{{ selected.detail.remote_addr || '-' }}</td>
                  </tr>
                  <tr>
                    <td class="detail-label">Waktu</td>
                    <td>{{ selected.detail.created_at | dateTimeFull }}</td>
                  </tr>
                </tbody>
              </v-simple-table>

              <div class="body-2 mb-2 black--text font-weight-medium">Pesan</div>
              <div class="detail-box mb-4">{{ selected.detail.message || '-' }}</div>

              <div class="body-2 mb-2 black--text font-weight-medium">User Agent</div>
              <div class="detail-box">{{ selected.detail.user_agent || '-' }}</div>
            </v-card-text>

            <v-divider class="mt-2" style="border-top: 2px dashed #e0e0e0;" />

            <v-card-actions class="pa-4">
              <v-spacer />
              <v-btn
                rounded
                width="120"
                @click="dialog.form = false; dialog.fullscreen = false;"
                elevation="0"
                outlined
                color="grey"
                class="body-2 font-weight-bold text-capitalize">
                Tutup
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <v-row class="pa-4 pb-0 pt-0">
            <v-col cols="12" class="pb-1">
              <v-card flat color="transparent">
                <div class="d-flex align-center">
                  <div class="d-flex align-center">
                    <v-avatar tile size="22">
                      <v-img
                        contain
                        alt="kominfoklaten"
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row class="fill-height" align="center" justify="center">
                            <v-progress-circular
                              size="20"
                              indeterminate
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span class="fs-16 black--text ml-2" style="font-weight: 600;">
                      Log E-Sign
                    </span>
                  </div>

                  <v-spacer />
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row justify="start" class="pa-4 py-0 pr-1">
            <v-col cols="12" md="12" class="d-flex align-center pb-1 flex-wrap">
              <v-menu
                v-model="menu.start_date"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="filter.start_date"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    clearable
                    v-bind="attrs"
                    v-on="on"
                    filled
                    rounded
                    dense
                    hide-details
                    :color="set_color"
                    placeholder="Dari Tanggal"
                    class="fs-12 little-placeholder mr-2"
                    style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 200px;"
                    @click:clear="filter.start_date = ''; fetch();">
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="filter.start_date"
                  @input="menu.start_date = false; onStartDateChange();"
                  :max="filter.end_date || today"
                  :color="set_color"
                  locale="id">
                </v-date-picker>
              </v-menu>

              <span class="mx-1 grey--text">–</span>

              <v-menu
                v-model="menu.end_date"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="filter.end_date"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    clearable
                    v-bind="attrs"
                    v-on="on"
                    filled
                    rounded
                    dense
                    hide-details
                    :color="set_color"
                    placeholder="Sampai Tanggal"
                    class="fs-12 little-placeholder ml-2"
                    style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 200px;"
                    @click:clear="filter.end_date = ''; fetch();">
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="filter.end_date"
                  @input="menu.end_date = false; fetch();"
                  :min="filter.start_date"
                  :max="today"
                  :color="set_color"
                  locale="id">
                </v-date-picker>
              </v-menu>

              <v-btn
                v-if="filter.start_date || filter.end_date"
                small
                text
                @click="resetFilter()"
                class="body-2 text-capitalize red--text ml-2"
                style="min-width: auto; height: 28px;">
                Reset
              </v-btn>
            </v-col>
          </v-row>

          <v-row
            v-if="activeFilters.length > 0"
            class="pa-4 pt-2 pb-2">
            <v-col cols="12" class="py-0">
              <div class="d-flex align-center flex-wrap">
                <span class="body-2 mr-2 black--text font-weight-medium">Filter Aktif:</span>
                <v-chip
                  v-for="(filterItem, index) in activeFilters"
                  :key="index"
                  small
                  close
                  @click:close="clearFilter(filterItem.key)"
                  :color="set_color"
                  text-color="white"
                  class="mr-2 mb-1"
                  style="height: 24px;">
                  {{ filterItem.label }}: {{ filterItem.value }}
                </v-chip>
                <v-btn
                  small
                  text
                  @click="resetFilter()"
                  class="body-2 text-capitalize red--text px-2"
                  style="min-width: auto; height: 24px;">
                  Clear All
                </v-btn>
              </div>
            </v-col>
          </v-row>

          <v-row class="pa-4 py-0">
            <v-col cols="12" class="py-0">
              <v-card flat style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <div class="view">
                  <div v-if="!process.load" :class="process.load || list.length === 0 ? '' : 'wrapper-pegawai'">
                    <table style="border-radius: 10px; width: 100%;" class="table">
                      <tr>
                        <th
                          :style="`background-color: ${set_color}; color: #fff;`"
                          class="sticky-col one-col"
                          style="z-index: 1; color: white; font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">
                          Aksi
                        </th>
                        <th
                          :style="`background-color: ${set_color}; color: #fff;`"
                          @click="sortBy !== 'created_at' ? toSort('created_at') : toDesc();"
                          style="width: 1px; white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Waktu
                          <span v-if="sortBy === 'created_at'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>
                        <th
                          :style="`background-color: ${set_color}; color: #fff;`"
                          style="width: 1px; white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Status
                        </th>
                        <th
                          :style="`background-color: ${set_color}; color: #fff;`"
                          style="width: 1px; white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          NIK
                        </th>
                        <th
                          :style="`background-color: ${set_color}; color: #fff;`"
                          style="color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Pesan
                        </th>
                        <th
                          :style="`background-color: ${set_color}; color: #fff;`"
                          style="width: 1px; white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          IP Address
                        </th>
                        <th
                          :style="`background-color: ${set_color}; color: #fff;`"
                          style="color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          User Agent
                        </th>
                      </tr>
                      <tr
                        v-for="(item, index) in list"
                        :key="item.id || index"
                        @click="selected.row = index"
                        :class="selected.row === index ? 'selected' : ''">
                        <td
                          class="sticky-col one-col"
                          style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 2px; text-align: center;"
                          :style="getCellStyle(item)">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                @click="openDetail(item)"
                                min-width="25"
                                height="25"
                                x-small
                                rounded
                                color="green"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 6px;">
                                <v-icon size="14">mdi-information-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>Detail</span>
                          </v-tooltip>
                        </td>
                        <td
                          style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px; white-space: nowrap; padding: 8px 12px; text-align: left;"
                          :style="getCellStyle(item)">
                          {{ item.created_at | dateTimeFull }}
                        </td>
                        <td
                          style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px; white-space: nowrap; padding: 8px 12px; text-align: left;"
                          :style="getCellStyle(item)">
                          <span
                            class="status-badge"
                            :style="{ backgroundColor: statusColor(item.parsed.status) }">
                            {{ item.parsed.status || '-' }}
                          </span>
                        </td>
                        <td
                          style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px; white-space: nowrap; padding: 8px 12px; text-align: left;"
                          :style="getCellStyle(item)"
                          class="detail-mono">
                          {{ item.parsed.nik || '-' }}
                        </td>
                        <td
                          style="font-size: 12px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; max-width: 360px;"
                          :style="getCellStyle(item)">
                          <div class="text-ellipsis">{{ item.message }}</div>
                        </td>
                        <td
                          style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px; white-space: nowrap; padding: 8px 12px; text-align: left;"
                          :style="getCellStyle(item)"
                          class="detail-mono">
                          {{ item.remote_addr || '-' }}
                        </td>
                        <td
                          style="font-size: 12px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; max-width: 280px;"
                          :style="getCellStyle(item)">
                          <div class="text-ellipsis">{{ item.user_agent || '-' }}</div>
                        </td>
                      </tr>
                    </table>
                  </div>

                  <v-card-text
                    v-if="process.load"
                    class="pb-0 my-4"
                    style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-4 title">
                        Mohon Tunggu . . .
                      </div>
                      <v-progress-linear
                        :color="set_color"
                        indeterminate
                        rounded
                        height="10">
                      </v-progress-linear>
                    </div>
                  </v-card-text>

                  <v-card-text
                    v-if="!process.load && list.length === 0"
                    class="pb-0 my-4"
                    style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <v-img
                        class="mx-auto"
                        contain
                        alt="vuetify"
                        :width="90"
                        :height="90"
                        :src="require('@/assets/image/empty.png')">
                      </v-img>
                      <div class="mt-3 fs-16">
                        Belum Ada Data
                      </div>
                    </div>
                  </v-card-text>

                  <pagination
                    v-if="!process.load && pagination.total_data > 0"
                    @changePage="fetch($event)"
                    @reloadPage="fetch($event)"
                    :model="pagination"
                    :display="paginationList" />
                </div>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get } from "@/service/Axios"
  import moment from "moment"
  import "moment/locale/id"

  export default {
    data () {
      return {
        dialog: {
          fullscreen: false,
          form: false
        },
        menu: {
          start_date: false,
          end_date: false
        },
        filter: {
          start_date: '',
          end_date: ''
        },
        selected: {
          row: [],
          detail: null
        },
        paginationList: {
          row: 20,
          page: 1
        },
        sortBy: 'created_at',
        sortDesc: '-',
        list: [],
        pagination: {},
        limit: 20,
        process: {
          load: false
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination_other.vue')
    },
    computed: {
      today () {
        return moment().format('YYYY-MM-DD')
      },
      set_color () {
        return this.$store.state.color
      },
      parsedDetail () {
        if (this.selected.detail && this.selected.detail.parsed) {
          return this.selected.detail.parsed
        }
        return this.parseMessage(this.selected.detail && this.selected.detail.message)
      },
      activeFilters () {
        const filters = []
        moment.locale('id')

        if (this.filter.start_date || this.filter.end_date) {
          const start = this.filter.start_date
            ? moment(this.filter.start_date).format('dddd, DD MMMM YYYY')
            : '...'
          const end = this.filter.end_date
            ? moment(this.filter.end_date).format('dddd, DD MMMM YYYY')
            : '...'
          filters.push({
            key: 'date',
            label: 'Tanggal',
            value: `${start} - ${end}`
          })
        }

        return filters
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      parseMessage (message) {
        const result = {
          action: '',
          version: '',
          status: '',
          nik: '',
          tampilan: '',
          env: ''
        }

        if (!message) return result

        String(message).split('|').map(part => part.trim()).forEach((part, index) => {
          if (index === 0) result.action = part
          else if (index === 1) result.version = part
          else if (index === 2) result.status = part
          else if (part.indexOf('nik=') === 0) result.nik = part.slice(4)
          else if (part.indexOf('tampilan=') === 0) result.tampilan = part.slice(9)
          else if (part.indexOf('env=') === 0) result.env = part.slice(4)
        })

        return result
      },
      statusColor (status) {
        const value = String(status || '').toLowerCase()
        if (value === 'sukses' || value === 'success') return '#2e7d32'
        if (value === 'gagal' || value === 'failed' || value === 'error') return '#c62828'
        return '#616161'
      },
      getCellStyle (item) {
        const status = String((item.parsed && item.parsed.status) || '').toLowerCase()
        if (status === 'sukses' || status === 'success') return 'background-color: #c8e6c9'
        if (status === 'gagal' || status === 'failed' || status === 'error') return 'background-color: #ffdede'
        return 'background-color: white'
      },
      toSort (name) {
        this.sortBy = name
        this.sortDesc = ''
        this.fetch()
      },
      toDesc () {
        this.sortDesc === '-' ? this.sortDesc = '' : this.sortDesc = '-'
        this.fetch()
      },
      onStartDateChange () {
        if (this.filter.end_date && this.filter.start_date && this.filter.end_date < this.filter.start_date) {
          this.filter.end_date = this.filter.start_date
        }
        this.fetch()
      },
      openDetail (item) {
        this.selected.detail = item
        this.dialog.form = true
      },
      resetFilter () {
        this.filter.start_date = ''
        this.filter.end_date = ''
        this.fetch()
      },
      clearFilter (key) {
        if (key === 'date') {
          this.filter.start_date = ''
          this.filter.end_date = ''
        }
        this.fetch()
      },
      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true
        this.limit = pagination.row
        this.paginationList = pagination

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: `${this.sortDesc}${this.sortBy}`,
          start_date: this.filter.start_date,
          end_date: this.filter.end_date
        }

        params = Object.entries(params).reduce((acc, [key, value]) => {
          const isEmpty =
            value === null ||
            value === undefined ||
            (typeof value === 'string' && value.trim() === '')

          if (!isEmpty) acc[key] = value
          return acc
        }, {})

        this.selected.row = []

        try {
          const response = await get('admin/sign/log', { params })
          const res = response.data

          this.list = []
          this.pagination = {}

          if (res.status === 200) {
            this.list = (res.results.data || []).map(item => ({
              ...item,
              parsed: this.parseMessage(item.message)
            }))
            this.pagination = res.results.pagination || {}
          }
        } catch (error) {
          this.list = []
          this.pagination = {}
        } finally {
          this.process.load = false
        }
      }
    }
  }
</script>

<style scoped>
  table, th, td {
    border-spacing: 4px;
    border-collapse: collapse;
  }

  .view {
    margin: auto;
  }

  .wrapper-pegawai {
    overflow-y: auto;
    height: calc(100vh - 265px);
  }

  .wrapper-pegawai th {
    position: sticky;
    top: 0;
  }

  .sticky-col {
    position: -webkit-sticky;
    position: sticky;
  }

  .one-col {
    width: 60px;
    min-width: 60px;
    max-width: 60px;
    left: 0px;
  }

  tr:hover {
    background-color: #1976d236;
  }

  tr.selected {
    background-color: #1976d236;
  }

  .text-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
  }

  .detail-mono {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    font-size: 12px;
  }

  .detail-label {
    width: 140px;
    color: #6b7280;
    font-weight: 600;
    white-space: nowrap;
  }

  .detail-box {
    background: #f7f8fa;
    border: 1px solid #e7e7e7;
    border-radius: 8px;
    padding: 12px;
    font-size: 12px;
    line-height: 1.5;
    word-break: break-word;
  }

  .status-badge {
    display: inline-block;
    color: #fff;
    border-radius: 4px;
    padding: 2px 8px;
    font-size: 11px;
    font-weight: 600;
    text-transform: capitalize;
  }
</style>
